import { render, staticRenderFns } from "./CreateDiscountBtn.vue?vue&type=template&id=25d2d27a&"
import script from "./CreateDiscountBtn.vue?vue&type=script&lang=js&"
export * from "./CreateDiscountBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports